export default () => {

  $('html').on('click', '.mobile-nav-mainnav-item-dropdown-open', (e) => {
    e.preventDefault();
    $(e.currentTarget).attr('data-open', $(e.currentTarget).attr('data-open') === 'true' ? 'false' : 'true');
    $(e.currentTarget).parent().next().slideToggle(150);
  });

};
